// extracted by mini-css-extract-plugin
export default {"cardHeaderIcon":"c-e_cC","cardHeaderIcon__content":"c-e_cE"};